import React from 'react';
import one from '../Images/icons-01.png'
import two from '../Images/icons-02.png'
import three from '../Images/icons-03.png'
import four from '../Images/icons-04.png'

function Icons() {
  return (
    <div className="max-w-[1200px] mx-auto py-[100px] px-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-[#5f6c33]">
      
      {/* Icon 1 */}
      <div className="flex flex-col items-center justify-center text-center">
        <img
          src={one}
          alt="Icon of a pill with a diagonal line crossing it out, colored olive green"
          className="w-[80px] h-[80px] md:w-[130px] md:h-[130px] object-contain mb-3"
        />
        <p className="font-bold text-base md:text-lg leading-[1.2]">
          No Pills <br /> Medicine
        </p>
      </div>

      {/* Icon 2 */}
      <div className="flex flex-col items-center justify-center text-center">
        <img
          src={two}
          alt="Icon of a water drop with a diagonal line crossing it out, colored olive green"
          className="w-[80px] h-[80px] md:w-[130px] md:h-[130px] object-contain mb-3"
        />
        <p className="font-bold text-base md:text-lg leading-[1.2]">
          No Fat <br /> Burners
        </p>
      </div>

      {/* Icon 3 */}
      <div className="flex flex-col items-center justify-center text-center">
        <img
          src={three}
          alt="Icon of a drink cup with a straw and a diagonal line crossing it out, colored olive green"
          className="w-[80px] h-[80px] md:w-[130px] md:h-[130px] object-contain mb-3"
        />
        <p className="font-bold text-base md:text-lg leading-[1.2]">
          No Diet <br /> Shakes
        </p>
      </div>

      {/* Icon 4 */}
      <div className="flex flex-col items-center justify-center text-center">
        <img
          src={four}
          alt="Icon of a weighing scale with a diagonal line crossing it out, colored olive green"
          className="w-[80px] h-[80px] md:w-[130px] md:h-[130px] object-contain mb-3"
        />
        <p className="font-bold text-base md:text-lg leading-[1.2]">
          No <br /> Machine
        </p>
      </div>
    </div>
  );
}

export default Icons;
